// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"78b28015","110":"d1c33b84","338":"aef6bd94","415":"6eea0d7f","460":"d8703d32","550":"aef6bd94","659":"7a3b6631","679":"aef6bd94","703":"aef6bd94","845":"4226fd93","978":"50747bdf"}[chunkId] + ".chunk.css";
};